import { jsx as _jsx } from "react/jsx-runtime";
import Grid from "@mui/material/Grid";
var GridItem = function (_a) {
    var item = _a.item, _b = _a.sizeXs, sizeXs = _b === void 0 ? "12" : _b, _c = _a.size, size = _c === void 0 ? "6" : _c;
    return (_jsx(Grid, { item: true, role: "listitem", xs: parseInt(sizeXs, 10), md: parseInt(size, 10), children: item }));
};
export default GridItem;
